import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/measures",
    name: "Measures",
    meta: { title: "Meritve" },
    component: () => import(/* webpackChunkName: "Measures List" */ "@/Modules/Measure/Views/List/List"),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/measures/details/:id",
    name: "Measure Details",
    component: () => import(/* webpackChunkName: "Measure Details" */ "@/Modules/Measure/Views/Details/Details"),
    beforeEnter: ifAuthenticated
  }
]
